export { VuesaxLinearArrowCircleRight3 } from "./VuesaxLinearArrowCircleRight3";
